import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';

interface NewsItem {
  title: string;
  description: string;
  date: string;
  source: string;
  url: string;
  category?: string;
}

const InTheNews: React.FC = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  // Add your news items here
  const newsItems: NewsItem[] = [
    {
      title: 'Psilocybin targets brain circuits to relieve chronic pain, depression',
      description: 'Penn Medicine researchers offer new insights into psilocybin\'s ability to break the pain-depression cycle.',
      date: 'October 2, 2025',
      source: 'Penn Medicine News',
      url: 'https://www.pennmedicine.org/news/psilocybin-targets-brain-circuits-to-relieve-pain',
      category: 'Pain research',
    },
    // Add more news items as needed
  ];

  return (
    <section
      ref={ref}
      className="py-20 md:py-28 bg-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
          transition={{ duration: 0.6 }}
          className="mb-12"
        >
          <div className="flex items-center justify-between mb-8">
            <h2 className="text-4xl md:text-5xl font-bold text-penn-blue">
              In the News
            </h2>
            <span className="text-sm font-semibold text-penn-red bg-penn-red/10 px-3 py-1 rounded-full">
              Penn Medicine in the News
            </span>
          </div>
          <div className="w-24 h-1 bg-penn-red"></div>
        </motion.div>

        <div className="space-y-6">
          {newsItems.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
              transition={{ duration: 0.6, delay: 0.2 + index * 0.1 }}
              className="bg-neutral-light rounded-lg p-6 md:p-8 hover:shadow-lg transition-shadow border border-neutral-medium"
            >
              {item.category && (
                <span className="inline-block text-xs font-semibold text-penn-red bg-penn-red/10 px-3 py-1 rounded-full mb-3">
                  {item.category}
                </span>
              )}
              <h3 className="text-2xl md:text-3xl font-bold text-penn-blue mb-3">
                <a
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-penn-red transition-colors"
                >
                  {item.title}
                </a>
              </h3>
              <p className="text-lg text-neutral-dark mb-2">
                {item.description}
              </p>
              <div className="flex items-center justify-between mt-4">
                <p className="text-sm text-neutral-dark/70">
                  {item.date} • {item.source}
                </p>
                <a
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-penn-red hover:text-penn-blue font-semibold transition-colors flex items-center"
                >
                  Read more
                  <svg
                    className="w-4 h-4 ml-1"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path d="M9 5l7 7-7 7" />
                  </svg>
                </a>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default InTheNews;




